
// src/actions/users.js

import api from './gamba-api'
import { emitAlertMessage, clearAlertMessage } from './alert-message'

export const FETCH_USER_INFO = "FETCH_USER_INFO"
export const FETCH_USER_INFO_REQUESTED = "FETCH_USER_INFO_REQUESTED"
export const FETCH_USER_INFO_COMPLETED = "FETCH_USER_INFO_COMPLETED"
export const FETCH_USER_INFO_FAILED = "FETCH_USER_INFO_FAILED"

export function fetchUserInfoRequested() {
  return {
    type: FETCH_USER_INFO_REQUESTED
  }
}

export function fetchUserInfo(user_id) {
  return function(dispatch) {
    dispatch(fetchUserInfoRequested())
    return api.get(`/users/${user_id}`)
        .then((results)=> {
          dispatch(fetchUserInfoCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchUserInfoFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchUserInfoCompleted(results) {
  return {
    type: FETCH_USER_INFO_COMPLETED,
    results,
  }
}

export function fetchUserInfoFailed(error) {
  return {
    type: FETCH_USER_INFO_FAILED,
    error,
  }
}



// WEBPACK FOOTER //
// ./src/actions/users.js